import { useEffect, useMemo } from "react";

/**
 * Inyecta <script type="application/ld+json"> en <head>.
 * Acepta un objeto o un array de objetos JSON-LD.
 */
export default function useJsonLd(data) {
  const json = useMemo(() => (data ? JSON.stringify(data) : null), [data]);

  useEffect(() => {
    if (!json) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-owner", "jsonld");
    el.text = json;
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
  }, [json]);
}
